var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueueScreenArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 33,
    viewBox: "0 0 39 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6994 0.341296L38.636 15.6013C38.8691 15.8398 39 16.163 39 16.5C39 16.837 38.8691 17.1602 38.636 17.3986L23.6994 32.6587C23.4634 32.8833 23.1513 33.0056 22.8289 32.9998C22.5064 32.994 22.1987 32.8605 21.9707 32.6275C21.7426 32.3945 21.612 32.0802 21.6063 31.7508C21.6006 31.4213 21.7203 31.1025 21.9402 30.8614L34.7504 17.7717L1.24472 17.7717C0.914596 17.7717 0.597998 17.6377 0.364568 17.3992C0.131138 17.1607 -7.06127e-07 16.8373 -7.20862e-07 16.5C-7.35597e-07 16.1627 0.131138 15.8393 0.364568 15.6008C0.597997 15.3623 0.914596 15.2283 1.24472 15.2283L34.7504 15.2283L21.9402 2.13859C21.7203 1.89753 21.6006 1.57868 21.6063 1.24923C21.612 0.919784 21.7426 0.605453 21.9707 0.372462C22.1987 0.139472 22.5064 0.00600716 22.8289 0.000193551C23.1513 -0.00562006 23.4634 0.116668 23.6994 0.341296Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueueScreenArrowRightIcon);
export default __webpack_public_path__ + "static/media/queueScreenArrowRightIcon.76b5705b296dcd8c585d19b843902f75.svg";
export { ForwardRef as ReactComponent };